export default (items, search) => {
    if (search.trim().length === 0) return items;

    const s = search.toLowerCase().replace(/,/g, ' ').replace(/  +/g, ' ');
    let searchKeys = s.split(' ');

    const match = (x) => {
        const name = x.label.toLowerCase().replace(/,/g, ' ').replace(/  +/g, ' ');
        return searchKeys.every(k => k === '' || name.includes(k))
    }

    return items.filter(x => match(x));
}